/* eslint-disable */
import React, { useMemo } from 'react';
import { Button } from 'antd';
import {LeftIcon, RightIcon, WTitle} from '../../components/Widget';
import ImgPoint from '../../../../../../assets/2025/arrow.gif';
import ImgPointBack from '../../../../../../assets/2025/black-arrow-gif.gif';
import ele_example_1_1 from '../../../../../../assets/2025/topic1000/ele_example_1_1.png';
import example_img_1_1 from '../../../../../../assets/2025/topic1000/example_img_1_1.png';
import example_img_1_2 from '../../../../../../assets/2025/topic1000/example_img_1_2.png';
import example_img_1_3 from '../../../../../../assets/2025/topic1000/example_img_1_3.png';
import example_img_1_4 from '../../../../../../assets/2025/topic1000/example_img_1_4.png';
import example_img_1_5 from '../../../../../../assets/2025/topic1000/example_img_1_5.png';
import example_img_1_6 from '../../../../../../assets/2025/topic1000/example_img_1_6.png';
import example_img_1_6_1 from '../../../../../../assets/2025/topic1000/example_img_1_6_1.png';
import example_img_1_7_1 from '../../../../../../assets/2025/topic1000/example_img_1_7_1.png';
import example_img_1_7 from '../../../../../../assets/2025/topic1000/example_img_1_7.png';
import ele_example_2_1 from '../../../../../../assets/2025/topic1000/ele_example_2_1.png';
import ele_example_2_2 from '../../../../../../assets/2025/topic1000/ele_example_2_2.png';
import ele_example_3_1 from '../../../../../../assets/2025/topic1000/ele_example_3_1.png';
import ele_example_3_2 from '../../../../../../assets/2025/topic1000/ele_example_3_2.png';

import ele_example_4_1 from '../../../../../../assets/2025/topic1000/ele_example_4_1.png';
import ele_example_4_2 from '../../../../../../assets/2025/topic1000/ele_example_4_2.png';
import ele_example_4_3 from '../../../../../../assets/2025/topic1000/ele_example_4_3.png';

import section3_1_2 from '../../../../../../assets/2025/topic1000/section3_1_2.png';
import section3_1_0 from '../../../../../../assets/2025/topic1000/section3_1_0.png';
import section3_2_1 from '../../../../../../assets/2025/topic1000/section3_2_1.png';
import section3_2_1_sc from '../../../../../../assets/2025/topic1000/section3_2_1_sc.png';
import section3_2_1_cn from '../../../../../../assets/2025/topic1000/section3_2_1_cn.png';
import section3_3_1 from '../../../../../../assets/2025/topic1000/section3_3_1.png';
import section3_3_2 from '../../../../../../assets/2025/topic1000/section3_3_2.png';
import section3_3_2_m from '../../../../../../assets/2025/topic1000/section3_3_2_m.png';
import section3_4_1 from '../../../../../../assets/2025/topic1000/section3_4_1.png';

import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';

import './section2.mobile.less';
import {useUpdateComponentState} from "../../../hooks";


interface ISection2Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const [state, setState] = React.useState({
    step: 0,
    completed: false,
    tapStep:0,
    // deepfakeFlag:false,
    // deepfakeFlag2:false,
    swithStatus:[true,false,false],
  });
  const { updateParagraphState, language } = useStore();
  const updateComponentState = useUpdateComponentState()
  React.useEffect(() => {
    // let flagArray=[state.completed,  state.deepfakeFlag, state.deepfakeFlag2]
    // if (!flagArray.includes(false) && !state.swithStatus.includes(false) ) {
    //   updateParagraphState(p_course, p_topic, ID, 'completed', []);
    // }
    if(state.completed){
      updateComponentState(p_course, p_topic, ID,'2025-topic1000-section2-1')
    }
    if(!state.swithStatus.includes(false)){
      updateComponentState(p_course, p_topic, ID,'2025-topic1000-section2-2')
    }
    // if(state.deepfakeFlag){
    //   updateComponentState(p_course, p_topic, ID,'2025-topic1000-section2-3')
    // }
    // if(state.deepfakeFlag2){
    //   updateComponentState(p_course, p_topic, ID,'2025-topic1000-section2-4')
    // }

  }, [
    p_course,
    p_topic,
    state.completed,
    state.swithStatus,
    // state.deepfakeFlag2,
    updateParagraphState,
  ]);

  const swithStep = (step: number) => {
    const nextStep = state.step + step;
    if (nextStep >= 6 && !state.completed) {
      setState({ ...state, step: nextStep, completed: true });
    } else {
      setState({ ...state, step: nextStep });
    }
  };

  const swithStep2 = (step: number) => {
    let newSwithStatus = [...state.swithStatus];
    newSwithStatus[step] = true;
    setState({ ...state, tapStep:step,swithStatus: newSwithStatus });
  };
  //查找下一个swithStatus的false 用于标识箭头显示
  function findStep2():number {
    return state.swithStatus.findIndex((item:boolean) => {
      return item === false;
    })
  };

  return (
    <div className="topic-section-2">
      <div className="_back">
        <div className="back_piece_t"></div>
      </div>
      <div className="padding_box">
        <WTitle title={paragraphsSettings?.title} />
        <div className="title_type2">
          <WTitle title={paragraphsSettings?.title_l} />
        </div>
        <div className="subtitle-box">
          <div className="subtitle">{paragraphsSettings?.l46}</div>
        </div>
        <div className="example_box">
          <div
            className="text_example_1_1"
            dangerouslySetInnerHTML={{ __html: paragraphsSettings?.l47 }}
          />
          <div className="text_example_1_2">{paragraphsSettings?.l48}</div>
          <img src={ele_example_1_1} className="eleImg_1_1" />
        </div>
        <div className="example_box_1" id='2025-topic1000-section2-1'>
          <div className="title_t1">{paragraphsSettings?.l49}</div>
          <div className="slide_box">
            <div className="bottom_arrow pc_hide">
                  <span
                    style={{display: state.step === 0 ? 'none' : ''}}
                    onClick={() => {
                      swithStep(-1);
                    }}
                  >
                    <LeftIcon fill={'#FE5506'}/>
                  </span>
              <span
                style={{display: state.step === 6 ? 'none' : ''}}
                onClick={() => {
                  swithStep(1);
                }}
              >
                  <RightIcon fill={'#FE5506'}/>
                  <img
                    src={ImgPoint}
                    alt=""
                    style={{display: state.completed ? 'none' : ''}}
                    className="arrow_icon"
                  />
                </span>
            </div>
            <div
              className="slide_list"
              style={{display: state.step === 0 ? '' : 'none'}}
            >
              <div className="title_box">
                <div className="title_left">
                  <div className="circle">
                    <em>01</em>
                  </div>
                  <div
                    className="center_text"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.l50,
                    }}
                  />
                </div>
              </div>
              <div className="example_img_type1">
                <div
                  className="right_text"
                  dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.l51,
                  }}
                />
                <img src={example_img_1_1}/>
              </div>
            </div>

            <div
              className="slide_list"
              style={{display: state.step === 1 ? '' : 'none'}}
            >
              <div className="title_box">
                <div className="title_left">
                  <div className="circle">
                    <em>02</em>
                  </div>
                  <div
                    className="center_text"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.l52,
                    }}
                  />
                </div>

              </div>
              <div className="example_img_type1">
                <div
                  className="right_text"
                  dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.l53,
                  }}
                />
                <img src={example_img_1_2}/>
              </div>
            </div>

            <div
              className="slide_list"
              style={{display: state.step === 2 ? '' : 'none'}}
            >
              <div className="title_box">
                <div className="title_left">
                  <div className="circle">
                    <em>03</em>
                  </div>
                  <div
                    className="center_text"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.l54,
                    }}
                  />
                </div>

              </div>
              <div className="example_img_type1">
                <div
                  className="right_text"
                  dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.l55,
                  }}
                />
                <img src={example_img_1_3}/>
              </div>
            </div>

            <div
              className="slide_list"
              style={{display: state.step === 3 ? '' : 'none'}}
            >
              <div className="title_box">
                <div className="title_left">
                  <div className="circle">
                    <em>04</em>
                  </div>
                  <div
                    className="center_text"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.l56,
                    }}
                  />
                </div>

              </div>
              <div className="example_img_type1">
                <div
                  className="right_text"
                  dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.l57,
                  }}
                />
                <img src={example_img_1_4}/>
              </div>
            </div>

            <div
              className="slide_list"
              style={{display: state.step === 4 ? '' : 'none'}}
            >
              <div className="title_box">
                <div className="title_left">
                  <div className="circle">
                    <em>05</em>
                  </div>
                  <div
                    className="center_text"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.l58,
                    }}
                  />
                </div>

              </div>
              <div className="example_img_type1">
                <div
                  className="right_text"
                  dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.l59,
                  }}
                />
                <img src={example_img_1_5}/>
              </div>
            </div>
            <div
              className="slide_list"
              style={{display: state.step === 5 ? '' : 'none'}}
            >
              <div className="title_box">
                <div className="title_left">
                  <div className="circle">
                    <em>06</em>
                  </div>
                  <div
                    className="center_text"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.l60,
                    }}
                  />
                </div>

              </div>
              <div className="example_img_type1">
                <div
                  className="right_text"
                  style={{textAlign: 'left'}}
                  dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.l61,
                  }}
                />
                <img src={example_img_1_6}/>
                <img src={example_img_1_6_1} className="example_161"></img>
              </div>
            </div>
            <div
              className="slide_list"
              style={{display: state.step === 6 ? '' : 'none'}}
            >
              <div className="title_box">
                <div className="title_left">
                  <div className="circle">
                    <em>07</em>
                  </div>
                  <div
                    className="center_text"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.l62,
                    }}
                  />
                </div>

              </div>
              <div className="example_img_type1">
                <div className="example_back_box">
                  <div
                    className="text"
                    style={{textAlign: 'left'}}
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.l63,
                    }}
                  />
                  <div className="img_box">
                    <img src={example_img_1_7_1} className="img_171"></img>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom_arrow mobile_show">
                  <span
                    style={{display: state.step === 0 ? 'none' : ''}}
                    onClick={() => {
                      swithStep(-1);
                    }}
                  >
                    <LeftIcon fill={'#FE5506'}/>
                  </span>
              <span
                style={{display: state.step === 6 ? 'none' : ''}}
                onClick={() => {
                  swithStep(1);
                }}
              >
                  <RightIcon fill={'#FE5506'}/>
                  <img
                    src={ImgPoint}
                    alt=""
                    style={{display: state.completed ? 'none' : ''}}
                    className="arrow_icon"
                  />
                </span>
            </div>
          </div>
        </div>

        {/*******模块2 即時通訊釣魚*******/}
      </div>
      <div className="padding_box">
        <div className="example_box2" style={{marginTop: '5rem'}}>
          <div className="title_type2" style={{'userSelect': "none"}}>
            <WTitle title={paragraphsSettings?.l64}/>
          </div>
          <div className="subtitle-box">
            <div className="subtitle">{paragraphsSettings?.l64}</div>
          </div>
          <div className="ele_box">
            <div className="left_img">
              <div className="text">
                {paragraphsSettings?.l66}
                <svg
                  width="15"
                  height="13"
                  viewBox="0 0 15 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.76795 12C6.53775 13.3333 8.46225 13.3333 9.23205 12L13.9952 3.75C14.765 2.41667 13.8027 0.75 12.2631 0.75L2.73686 0.75C1.19726 0.75 0.235009 2.41667 1.00481 3.75L5.76795 12Z"
                    fill="#77B0E8"
                  />
                </svg>
              </div>
              <img src={ele_example_2_1}/>
            </div>
            <div className="right_img">
              <div className="text">
                {paragraphsSettings?.l67}
                <svg
                  width="15"
                  height="13"
                  viewBox="0 0 15 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.76795 12C6.53775 13.3333 8.46225 13.3333 9.23205 12L13.9952 3.75C14.765 2.41667 13.8027 0.75 12.2631 0.75L2.73686 0.75C1.19726 0.75 0.235009 2.41667 1.00481 3.75L5.76795 12Z"
                    fill="#EE6E2F"
                  />
                </svg>
              </div>
              <img src={ele_example_2_2}/>
            </div>
          </div>
          <div className="ele_box2">
            <div className="title_t">{paragraphsSettings?.l68}</div>
            <div className="content_box">
              <div className="text">
                <img src={ele_example_3_1} className="ele_img" alt=""/>
                <p dangerouslySetInnerHTML={{__html: paragraphsSettings?.l69}}></p>
                <p className="text_p" dangerouslySetInnerHTML={{__html: paragraphsSettings?.l69b}}></p>
                <div className="text2">
                  <span>{paragraphsSettings?.l69t}</span>
                </div>
                <a href={paragraphsSettings?.l69a} className="text_a" target="_blank">{paragraphsSettings?.l69a2}</a>
              </div>
              <img src={ele_example_3_2} className="ele_img2" alt=""/>
            </div>
          </div>
        </div>

        {/*******模块3 即時通訊網絡釣魚*******/}
        <div className="example_box3" id="2025-topic1000-section2-2" style={{marginTop: '5rem'}}>
          <div className="subtitle-box">
            <div className="subtitle">{paragraphsSettings?.l70}</div>
          </div>
          <div className="swith_box">
            <div className="nav_box">
              <div
                className={`nav_item ${
                  state.swithStatus[0] && state.tapStep === 0 && 'active'
                }`}
                onClick={() => {
                  swithStep2(0);
                }}
              >
                <span>{paragraphsSettings?.l71}</span>
              </div>

              <div
                className={`nav_item ${
                  state.swithStatus[1] && state.tapStep === 1 && 'active'
                }`}
                onClick={() => {
                  swithStep2(1);
                }}
              >
                <span>{paragraphsSettings?.l73}</span>
                <img
                  src={ImgPoint}
                  alt=""
                  style={{display: findStep2() === 1 ? 'block' : 'none'}}
                  className="arrow_icon"
                />
              </div>

              <div
                className={`nav_item ${
                  state.swithStatus[2] && state.tapStep === 2 && 'active'
                }`}
                onClick={() => {
                  swithStep2(2);
                }}
              >
                <span>{paragraphsSettings?.l75}</span>
                <img
                  src={ImgPoint}
                  alt=""
                  style={{
                    display: findStep2() === 2 ? 'block' : 'none',
                  }}
                  className="arrow_icon"
                />
              </div>
            </div>
            <div className="swith_img_box">
              <div
                className="swith_img"
                style={{display: state.tapStep === 0 ? 'block' : 'none'}}
              >
                <img src={ele_example_4_1}/>
                <div
                  style={{right: '0'}}
                  className="text"
                  dangerouslySetInnerHTML={{__html: paragraphsSettings?.l72}}
                />
              </div>
              <div
                className="swith_img"
                style={{
                  left: '0',
                  display: state.tapStep === 1 ? 'block' : 'none',
                }}
              >
                <img src={ele_example_4_2}/>
                <div
                  className="text"
                  dangerouslySetInnerHTML={{__html: paragraphsSettings?.l74}}
                />
              </div>
              <div
                className="swith_img"
                style={{
                  left: '0',
                  display: state.tapStep === 2 ? 'block' : 'none',
                }}
              >
                <img src={ele_example_4_3}/>
                <div
                  className="text"
                  dangerouslySetInnerHTML={{__html: paragraphsSettings?.l76}}
                />
              </div>
            </div>
          </div>
        </div>
        {/*******模块4 如何在日常工作中防範即時通訊釣魚？*******/}
        {/*<div className="example_box4" style={{ marginTop: '5rem',display:'none' }}>*/}
        {/*  <div className="subtitle-box no_back">*/}
        {/*    <div className="subtitle">{paragraphsSettings?.l77}</div>*/}
        {/*  </div>*/}
        {/*  <div className="handle-pic-container">*/}
        {/*    <div className="handle-pic-left"></div>*/}
        {/*    <div className="handle-pic-right">*/}
        {/*      <div className="dialog-box-1" onClick={()=>{ setState({...state,textFlag:true})}}>*/}
        {/*        <div className="text">*/}
        {/*          <p>{paragraphsSettings?.l78}</p>*/}
        {/*        </div>*/}
        {/*        <div className="img-wrap" style={{display:state.textFlag?'none':'block'}}>*/}
        {/*          <img src={ImgPoint} alt="" />*/}
        {/*        </div>*/}
        {/*        <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
        {/*          <path d="M12.8559 20L25.4 0.5H0.311686L12.8559 20Z" fill="#EBEBEB"/>*/}
        {/*        </svg>*/}
        {/*      </div>*/}
        {/*      <div className="dialog-box-2" style={{display:state.textFlag?'block':'none'}}>*/}
        {/*        <div className="text" style={{paddingRight:'3rem'}}>*/}
        {/*          <p>{paragraphsSettings?.l79}</p>*/}
        {/*        </div>*/}
        {/*        <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
        {/*          <path d="M12.8559 20L25.4 0.5H0.311686L12.8559 20Z" fill="#EBEBEB"/>*/}
        {/*        </svg>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*  <div className="handle-steps-container">*/}
        {/*    <div className="steps-left">*/}
        {/*      <div*/}
        {/*        className="text"*/}
        {/*        dangerouslySetInnerHTML={{*/}
        {/*          __html: paragraphsSettings?.l80,*/}
        {/*        }}*/}
        {/*      />*/}
        {/*    </div>*/}
        {/*    <div*/}
        {/*      className={`right_box ${state.example4 && 'animation_box'}`}*/}
        {/*    >*/}
        {/*      <div className="text_item" onClick={()=>{ setState({...state,example4:true})}}>*/}
        {/*        <img*/}
        {/*          src={ImgPoint}*/}
        {/*          alt=""*/}
        {/*          style={{display: state.example4 ? 'none' : ''}}*/}
        {/*          className="arrow_icon"*/}
        {/*        />*/}
        {/*        <div className="inner">*/}
        {/*          <em>01</em>*/}
        {/*          {paragraphsSettings?.l81}*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*      <div className="text_item">*/}
        {/*        <div className="inner">*/}
        {/*          <em>02</em>*/}
        {/*          {paragraphsSettings?.l82}*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*      <div className="text_item">*/}
        {/*        <div className="inner">*/}
        {/*          <em>03</em>*/}
        {/*          {paragraphsSettings?.l83}*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*      <div className="text_item">*/}
        {/*        <div className="inner">*/}
        {/*          <em>04</em>*/}
        {/*          {paragraphsSettings?.l84}*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*      <div className="text_item">*/}
        {/*        <div className="inner">*/}
        {/*          <em>05</em>*/}
        {/*          {paragraphsSettings?.l85}*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
      <div className="t1000_custom">
        <div className="padding_box">
          <div className="title_type2">
            <WTitle title={paragraphsSettings?.title_l1} />
          </div>
          <div className="example_box_5">
            <div className="subtitle-box">
              <div className="subtitle">{paragraphsSettings?.bl45}</div>
            </div>
            <img src={section3_1_2} alt="" className="left_img" />
            <img src={section3_1_0} alt="" className="left_img2" />
            <div
              className="text_box"
              dangerouslySetInnerHTML={{ __html: paragraphsSettings?.bl46 }}
            />
            <div className="text_a_box">
              <div className="text2">
                <span>{paragraphsSettings?.bl46t}</span>
              </div>
              <a href={paragraphsSettings?.bl46a} className="text_a" target="_blank">{paragraphsSettings?.bl46a2}</a>
            </div>
          </div>
          <div className="example_box_6">
            <div className="subtitle-box">
              <div className="subtitle">{paragraphsSettings?.bl47}</div>
            </div>
            <div className="text_box">{paragraphsSettings?.bl48}</div>
            <img src={section3_2_1_sc} alt="" className={`img_box_6 ${language === 'tc' ? 'img_show' : ''}`}/>
            <img src={section3_2_1} alt="" className={`img_box_6 ${language === 'en' ? 'img_show' : ''}`}/>
            <img src={section3_2_1_cn} alt="" className={`img_box_6 ${language === 'sc' ? 'img_show' : ''}`}/>
          </div>
          {/*<div className="example_box_7" id='2025-topic1000-section2-3'>*/}
          {/*  <div className="subtitle-box">*/}
          {/*  <div className="subtitle">{paragraphsSettings?.bl49}</div>*/}
          {/*  </div>*/}
          {/*  <div className="content_box">*/}
          {/*    <img src={section3_3_1} alt="" className="l1 pc_hide" />*/}
          {/*    <div className="l2">*/}
          {/*      <div*/}
          {/*        className="left"*/}
          {/*        style={{display: state.deepfakeFlag ? '' : 'none'}}*/}
          {/*      >*/}
          {/*        <p className="p1">{paragraphsSettings?.bl51}</p>*/}
          {/*        <p*/}
          {/*          className="p2"*/}
          {/*          dangerouslySetInnerHTML={{__html: paragraphsSettings?.bl52}}*/}
          {/*        />*/}
          {/*        <p className="p1">{paragraphsSettings?.bl53}</p>*/}
          {/*      </div>*/}
          {/*      <div*/}
          {/*        className="right"*/}
          {/*        onClick={() => setState({...state, deepfakeFlag: true})}*/}
          {/*      >*/}
          {/*        <span className="p1">{paragraphsSettings?.bl54}</span>*/}
          {/*        <img*/}
          {/*          src={ImgPoint}*/}
          {/*          alt=""*/}
          {/*          style={{display: state.deepfakeFlag ? 'none' : ''}}*/}
          {/*          className="arrow_icon"*/}
          {/*        />*/}
          {/*      </div>*/}
          {/*      <img src={section3_3_2} alt="" className="pc_hide"/>*/}
          {/*      <img src={section3_3_2_m} alt="" className="mobile_show img_pic"/>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
        {/*<div className="example_box_8" id='2025-topic1000-section2-4'>*/}
        {/*  <div className="padding_box">*/}
        {/*    <div className="subtitle-box">*/}
        {/*      <div className="subtitle">{paragraphsSettings?.bl60}</div>*/}
        {/*    </div>*/}
        {/*    <div className="content_box" >*/}
        {/*      <div  className="img_box" >*/}
        {/*        <img src={section3_4_1} alt="" />*/}
        {/*      </div>*/}
        {/*      <div*/}
        {/*        className={`right_box ${state.deepfakeFlag2 && 'animation_box'}`}*/}
        {/*      >*/}
        {/*        <div className="text_item" onClick={() => setState({ ...state, deepfakeFlag2: true})}>*/}
        {/*          <img*/}
        {/*            src={ImgPoint}*/}
        {/*            alt=""*/}
        {/*            style={{display: state.deepfakeFlag2 ? 'none' : ''}}*/}
        {/*            className="arrow_icon"*/}
        {/*          />*/}
        {/*          <div className="inner">*/}
        {/*            <em>01</em>*/}
        {/*            {paragraphsSettings?.bl61}*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*        <div className="text_item">*/}
        {/*          <div className="inner">*/}
        {/*            <em>02</em>*/}
        {/*            {paragraphsSettings?.bl62}*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*        <div className="text_item">*/}
        {/*          <div className="inner">*/}
        {/*            <em>03</em>*/}
        {/*            {paragraphsSettings?.bl63}*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*        <div className="text_item">*/}
        {/*          <div className="inner">*/}
        {/*            <em>04</em>*/}
        {/*            {paragraphsSettings?.bl64}*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*        <div className="text_item">*/}
        {/*          <div className="inner">*/}
        {/*            <em>05</em>*/}
        {/*            {paragraphsSettings?.bl65}*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*  <div className="back_piece"></div>*/}
        {/*</div>*/}
      </div>


    </div>
  );
};
export default Section2;
